import { useQuery } from 'convex/react';
import { api } from '../../convex/_generated/api';
import type { Id } from '../../convex/_generated/dataModel';
import { useConvexMutation } from './use-convex-mutation';

export type SessionType =
  | 'group'
  | 'private'
  | 'clinic'
  | 'match_play'
  | 'cardio_tennis'
  | 'squads';

export interface PlayerEnrollment {
  id: Id<'enrollments'>;
  sessionType: SessionType;
  termId: Id<'terms'>;
  termName: string;
  termStartDate: string;
  termEndDate: string;
  createdAt: number;
}

export function usePlayerEnrollments(playerId: Id<'players'> | null) {
  const data = useQuery(
    api.director.enrollments.listForPlayer,
    playerId ? { playerId } : 'skip'
  );
  return { data: data ?? null, isLoading: data === undefined };
}

export function useCreateEnrollment() {
  const { mutateAsync, isPending } = useConvexMutation(
    api.director.enrollments.create
  );
  return {
    isPending,
    mutateAsync: (args: {
      playerId: Id<'players'>;
      termId: Id<'terms'>;
      sessionType: SessionType;
    }) => mutateAsync(args),
  };
}

export function useRemoveEnrollment() {
  const { mutateAsync, isPending } = useConvexMutation(
    api.director.enrollments.remove
  );
  return {
    isPending,
    mutateAsync: (enrollmentId: Id<'enrollments'>) =>
      mutateAsync({ enrollmentId }),
  };
}
